import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from 'interfaces';

import Layout from 'components/Layout';
import HistoryComponent from 'components/History';
import Loader from 'components/ui/Loader';

import { getAllHistoryData } from './historySlice';


const History = () => {

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getAllHistoryData());
  }, [dispatch]);

  const history = useSelector((state: RootState) => state.history.history);

  return history ? (
    <Layout>
      <HistoryComponent historyYear={history} />
    </Layout>
  ) : <Loader />;
};

export default History;
